export const CUSTOM_EVENTS = {
  DEFAULT_TEXT_CHANGE: 'default-text-change'
} as const;
export type ICustomEvents = (typeof CUSTOM_EVENTS)[keyof typeof CUSTOM_EVENTS];
